import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MetaTagsService } from '../../services/meta-tags/meta-tags.service';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-terms',
  standalone: true,
  imports: [BreadcrumbComponent],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss',
})
export class TermsComponent {
  constructor(
    private activatedRoute: ActivatedRoute,
    private metaServices: MetaTagsService
  ) {}

  ngOnInit() {
    this.activatedRoute.url.subscribe((url) => {
      this.metaServices.configTagPages(
        MetaTagsService.PAGE_TERMS,
        url[0]?.path,
        '',
        '',
        null
      );
    });
  }
}
